import React from "react";
import { graphql } from "gatsby";
import { HighlightedSection } from "./HighlightedSection";
import {
  KontentComponentLayout,
  KontentComponentSettings,
  kontentImage,
  KontentLinkedImage,
  KontentLinkedVectorArt,
  KontentLinkedVideo,
  KontentMultiChoice,
  KontentRichText,
  KontentVideo,
  StringValue,
} from "../../../types";
import { getComponentSettings } from "../../../lib/componentSettings";
import { formatImages, formatVector } from "../../../lib/images";
import { getMultiChoice } from "../../../lib/multichoice";
import { formatVideo } from "../../../lib/videos";

export type MediaPlacement = "left" | "right";
export type StyleOptions = "transparent" | "light" | "dark";

interface Props extends KontentComponentLayout, KontentComponentSettings {
  media: KontentLinkedImage | KontentLinkedVideo;
  vector: KontentLinkedVectorArt;
  heading: StringValue;
  text: KontentRichText;
  style: KontentMultiChoice<StyleOptions>;
  media_placement: KontentMultiChoice<MediaPlacement>;
}

const HighlightedSectionContainer: React.FC<Props> = ({
  media,
  vector,
  heading,
  text,
  media_placement,
  style,
  ...props
}) => {
  const settings = getComponentSettings({ ...props });

  const formattedMedia =
    media.value[0].system.type === "video"
      ? formatVideo(media?.value[0].elements as KontentVideo["elements"])
      : formatImages(media?.value[0]?.elements as kontentImage["elements"]);
  const formattedVector = formatVector(vector.value[0].elements);
  return (
    <HighlightedSection
      media={formattedMedia}
      vector={formattedVector}
      heading={heading.value}
      text={text}
      style={getMultiChoice(style) || "dark"}
      mediaPlacement={getMultiChoice(media_placement)}
      {...settings}
    ></HighlightedSection>
  );
};

export default HighlightedSectionContainer;

export const fragmentHighlightedSectionContainer = graphql`
  fragment HighlightedSection on kontent_item_highlighted_section {
    elements {
      media {
        value {
          ...kontentImage
          ...kontentVideo
        }
      }
      vector {
        value {
          ...kontentVectorArt
        }
      }
      heading {
        value
      }
      text {
        ...kontentSimpleRichText
      }
      media_placement {
        value {
          codename
        }
      }
      style {
        value {
          codename
        }
      }
      component_layout__component_width {
        value {
          codename
        }
      }
      component_settings__anchor_name {
        value
      }
      component_settings__hide_on_mobile {
        value {
          codename
        }
      }
    }
  }
`;
